import api from './api';

/**
 * Matching Service
 * Handles all matching-related API calls (matching offers with requests)
 */
const matchingService = {
    /**
     * Get all matches (general)
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getMatches: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/matching${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get matches for my offers
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getMyMatches: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/matching${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get matches for a specific offer
     * @param {string} offerId - Offer ID
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getMatchesForOffer: async (offerId, params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/matching/offer/${offerId}${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get matches for a specific request
     * @param {string} requestId - Request ID
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getMatchesForRequest: async (requestId, params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/matching/request/${requestId}${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Run matching for a specific request
     * This will find all matching offers for the given request
     * @param {string} requestId - Request ID
     * @returns {Promise<Object>}
     */
    runMatching: async (requestId) => {
        return api.post(`/user/matching/run/${requestId}`);
    },

    /**
     * Run matching for all requests
     * @returns {Promise<Object>}
     */
    runMatchingForAll: async () => {
        return api.post(`/user/matching/run-all`);
    },

    /**
     * Update match status (interested, contacted, etc.)
     * @param {string} matchId - Match ID
     * @param {string} status - New status
     * @returns {Promise<Object>}
     */
    updateStatus: async (matchId, status) => {
        return api.patch(`/user/matching/${matchId}/status`, { status });
    }
};

export default matchingService;
